import React, { Component } from 'react';
import cx from 'classnames';

class AmaiaInput extends Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
  }

  componentDidMount() {
    this.adjustHeight();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.inputValue !== this.props.inputValue) {
      this.adjustHeight();
    }
    // UX: Auto-focus para mantener flujo de escritura.
    if (prevProps.isAIResponding && !this.props.isAIResponding) {
      if (this.textAreaRef.current) {
        this.textAreaRef.current.focus();
      }
    }
  }

  render() {
    const { helperTraslatedCopy, inputValue, isAIResponding, onSendMessage, showChat } = this.props;

    const sendBtnClasses = cx('AmaiaChat-send-btn', {
      'is-active': inputValue.trim() && !isAIResponding,
    });

    const placeholderText = isAIResponding 
      ? '' 
      : (helperTraslatedCopy ? helperTraslatedCopy.getFormatMessageFromcopyId(showChat ? 'AMAIA_WRITE_HERE_YOUR_ANSWER' : 'AMAIA_ASK_ME_A_QUESTION') : '');

    return (
      <div className='AmaiaChat-footer'>
        <div className='AmaiaChat-input-group'>
          <textarea
            className='AmaiaChat-input'
            disabled={ isAIResponding }
            maxLength='1000'
            onChange={ this.handleInputChange }
            onKeyDown={ this.handleKeyDown }
            placeholder={ placeholderText }
            ref={ this.textAreaRef }
            rows='1'
            value={ inputValue }
          />
          <button
            className={ sendBtnClasses }
            disabled={ !inputValue.trim() || isAIResponding }
            onClick={ onSendMessage }
          >
            <i className='Icon Icon--search' />
          </button>
        </div>
      </div>
    );
  }

  adjustHeight = () => {
    window.requestAnimationFrame(() => {
      const element = this.textAreaRef.current;
      if (element) {
        element.style.height = 'auto';
        element.style.height = `${ element.scrollHeight }px`;
      }
    });
  }

  handleInputChange = (e) => {
    const { isAIResponding, onInputChange } = this.props;
    if (isAIResponding) return;
    onInputChange(e.target.value);
  }

  handleKeyDown = (e) => {
    const { inputValue, isAIResponding, onSendMessage } = this.props;
    // Enter envía, Shift+Enter salta línea.
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isAIResponding && inputValue.trim() !== '') {
        onSendMessage();
      }
    }
  }
}

export default AmaiaInput;
